import { useTranslation } from "react-i18next";

import { EEmailEventType } from "../../emailNotifications.types";
import { EVENT_TYPE_COLORS, EVENT_TYPE_LABELS } from "../../constants";

import styles from "./EventTypeBadge.module.scss";

interface EventTypeBadgeProps {
  eventType: EEmailEventType;
}

const EventTypeBadge = ({ eventType }: EventTypeBadgeProps) => {
  const { t } = useTranslation();
  const color = EVENT_TYPE_COLORS[eventType];

  return (
    <span
      className={styles.badge}
      style={{ color, backgroundColor: `${color}1a` }}
    >
      {t(EVENT_TYPE_LABELS[eventType])}
    </span>
  );
};

export default EventTypeBadge;
